/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react'
import 'antd/dist/antd.css'
import { useDispatch } from 'react-redux'
import { connect } from 'react-redux'
import { Menu, Input, Breadcrumb, Radio, message, Spin, Pagination, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import ServiceCard from 'components/ServiceCard'
import { storageData, clearstorageData } from 'redux/storage'
import { useTranslation } from 'react-i18next'
import { GetSubscriptions, frontendGetSubscriptions } from 'api/hub'
import { history } from 'redux/store'
import moment from 'moment'

const Service = (props) => {
  // Basic Setting
  const dispatch = useDispatch()
  // i18n language switch
  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)
  const [page, setPage]=useState(1)
  const [pageSize, setPageSize]=useState(5)
  const [statuscode, setstatuscode] = useState({
    status_desc_en: "",
    status_desc_tw: ""
  })
  const [filter, setFilter]=useState("active")

  // Search Component
  const { Search } = Input
  // Radio Data
  const [options, setOptions] = useState([
    { label: localStorage.getItem('lang')==='en'?'all':'全部', value: 'all' },
    // { label: `${t('Subscription.applying')}`, value: '2', disabled: true },
    // { label: `${t('Subscription.quoted')}`, value: '3', disabled: true },
    // { label: `${t('Subscription.pending_payment')}`, value: '4', disabled: true },
    // { label: `${t('Subscription.paid')}`, value: '5', disabled: true },
    //{ label: `${t('Subscription.activated')}`, value: '6' },
    // { label: `${t('Subscription.terminated')}`, value: '7', disabled: true },
    // { label: `${t('Subscription.cancelled')}`, value: '8', disabled: true },
  ]);
  const [options1, setOptions1] = useState({
    'tw':[
      { label:'全部', value: 'all' },
    ],
    'en':[
      { label:'all', value: 'all' },
    ]
  });
  // Radio Function
  const onChange = e => {
    // console.log(e.target.value);
    setFilter(e.target.value);
  }
  // Search
  const handleSearch = value => {
    // console.log(value)
    setLoading(true)
    const tenantId = JSON.parse(localStorage.getItem('LoginInfo')).tenantId
    const operator_id = JSON.parse(localStorage.getItem('LoginInfo')).operator_id
    value?history.push(`/portal/service?search=${value}`):history.push('/portal/service')
    dispatch(GetSubscriptions({
        "tenant_id": tenantId,
        "ip_address": "1.1.1.1",
        "operator_id": operator_id,
        // "service_id": "string",
        "keyword": value,
        "page_record_set": 1000,
      })).then(
      res => { 
        setLoading(false)
        if(Object.keys(res).length > 2 && res.data && res.data !== undefined){
          setSubscriptionList(() => res.data.subscriptions.subscription_data ? res.data.subscriptions.subscription_data : []) 
        } else {
          setSubscriptionList(() => []) 
        }
       }
      )
  }

  // Get Subscription List
  const [SubscriptionList, setSubscriptionList] = useState([])
  const url = new URL(window.location.href)
  const searchValue = url.searchParams.get("search")?url.searchParams.get("search"):""
  useEffect(()=>{
    if(localStorage.getItem('direct_url')){
      const direct = localStorage.getItem('direct_url')
      localStorage.removeItem('direct_url');
      window.location.assign(direct)
    }

    const tenantId = JSON.parse(localStorage.getItem('LoginInfo')).tenantId
    const operator_id = JSON.parse(localStorage.getItem('LoginInfo')).operator_id
    // console.log(searchValue)
    setLoading(true)
    dispatch(GetSubscriptions(
      {
        "tenant_id": tenantId,
        "ip_address": "1.1.1.1",
        "operator_id": operator_id,
        // "service_id": "string",
        "keyword": searchValue,
        "page_record_set": 1000,
      }
      ))
      // dispatch(frontendGetSubscriptions({tenant_id:tenantId,keyword:searchValue}))
      .then(
        res => { 
          setLoading(false)
          if(res.data && res.data.subscriptions && res.data.subscriptions.subscription_data){
          if(res.data.subscriptions?.lookup_data){
            // if(options.length<2){
            //   setOptions([...options,...res.data.subscriptions?.lookup_data.map(i=> {return { label: localStorage.getItem('lang')==='en'?i.status_desc_en:i.status_desc_tw, value: i.lookup_code }})])
            //   setFilter("active")
            // }
            if(options1?.tw?.length<2){
              setOptions1({
                'tw':[...options1.tw,...res.data.subscriptions?.lookup_data.map(i=> {
                return { label: i.status_desc_tw, value: i.lookup_code }
                })],
                'en':[...options1.en,...res.data.subscriptions?.lookup_data.map(i=> {
                  return { label: i.status_desc_en, value: i.lookup_code }
                }
                )]
              })
              setFilter("active")
            }
          }
          if(Object.keys(res).length > 2){
            setSubscriptionList(() => res.data.subscriptions.subscription_data ? res.data.subscriptions.subscription_data : [])
          }
          }else{
            setSubscriptionList(() => []) 
          }
         }
        )
      }
  ,[])
  
  const onShowSizeChange = (current, pageSize) => {
    // console.log(current, pageSize);
    setPageSize(pageSize)
  };

  const onPageChange = (current) =>{
    // console.log(current)
    setPage(current)
  }

  // console.log(SubscriptionList)
  const currentTableData = useMemo(() => {
    const firstPageIndex = (page - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;

    if(SubscriptionList){
      return SubscriptionList.filter(i=>{return filter === 'all' || i.status === filter}).slice(firstPageIndex, lastPageIndex);
    }
    else{
      return []
    }
  }, [page, pageSize, SubscriptionList, filter]);



  const currentTableLength = useMemo(() => {
    const firstPageIndex = (page - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;

    if(SubscriptionList){
      return SubscriptionList.filter(i=>{return filter === 'all' || i.status === filter});
    }
    else{
      return []
    }
  }, [SubscriptionList, filter]);





  // console.log(currentTableData)
  const downloadFile = () => {
    // const {myData} = {subscriptions:SubscriptionList}
    const myData = {subscriptions:SubscriptionList}
    // create file in browser
    const fileName = moment().format('YYYYMMDDhmmss');
    // console.log(myData)
    const json = JSON.stringify(myData, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const href = URL.createObjectURL(blob);

    // create "a" HTLM element with href to file
    const link = document.createElement("a");
    link.href = href;
    link.download = fileName + ".json";
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }

  return (
    <>
       <div className='innerlayout' style={{padding: '36px 0 0 130px', minHeight: '1500px'}}>
       <Spin tip={t('Global.Loading')} spinning={loading} style={{padding: '36px 0 0 130px'}}>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>WiAdvance App Market</Breadcrumb.Item>
            <Breadcrumb.Item >{t('Global.member_center')}</Breadcrumb.Item>
            <Breadcrumb.Item className='lastchild'>{t('Menu.subscriptions')}</Breadcrumb.Item>
          </Breadcrumb>
          <div className='headtitle'>
            {t('Menu.subscriptions')}
          </div>
          <Radio.Group 
            value={filter}
            optionType="button"
            buttonStyle="solid"
            options={localStorage.getItem('lang')==='en'?options1?.en:options1?.tw}
            onChange={onChange} 
            />
          <div className='searchbar' style={{width : '100%'}}>
            <div className='mid'>
              <Search
                onSearch={handleSearch}
                defaultValue={searchValue}
                enterButton={t('Subscription.search')}
                allowClear
                size="large"
                placeholder={t('Subscription.search_your_subscription')}
                prefix={<SearchOutlined className="site-form-item-icon" />}
              />
            </div>
          </div>
          <div className="wibtn" style={{width:"150px", marginTop: "20px"}}>
            <Button type="primary" htmlType="submit" onClick={downloadFile}>{t('Global.export')}</Button>
          </div>
          <div className='scroll' style={{ width: '100%'}}>
          {
            currentTableLength.length > 5? <div style={{margin:'20px', float: 'right'}}>
              <Pagination
                locale={{ items_per_page: `/ ${t('Global.PageSizeText')}`}}
                pageSize={pageSize}
                current={page}
                pageSizeOptions={[5,10,20,50]}
                showSizeChanger
                onChange={onPageChange}
                onShowSizeChange={onShowSizeChange}
                total={currentTableLength?currentTableLength.length:0}
              />
            </div>:null
          }
          {
            currentTableData.map(item => {
              return <ServiceCard data={{
                ...item,
                'sub_status': {
                  status_desc_en: options1?.en?.filter(i=>{return i.value == item.status})[0]?.label,
                  status_desc_tw: options1?.tw?.filter(i=>{return i.value == item.status})[0]?.label
                }
              }} type='list'></ServiceCard>
            })
          }
          {
          currentTableLength.length > 5? <div style={{margin:'20px', float: 'right'}}>
            <Pagination
              locale={{ items_per_page: `/ ${t('Global.PageSizeText')}`}}
              pageSize={pageSize}
              current={page}
              pageSizeOptions={[5,10,20,50]}
              showSizeChanger
              onChange={onPageChange}
              onShowSizeChange={onShowSizeChange}
              total={currentTableLength?currentTableLength.length:0}
            />
            </div>:null
          }
          </div>
          </Spin>
      </div>
    </>
  )
}
// 將store中的items值傳綁到props上
const mapStateToProps = store => (
  { storeData: store.storeData }
)
const mapDispatchToProps = dispatch => {
  return {
    storageData: (payload) => {
      dispatch(storageData(payload))
    },
    clearstorageData: () => {
      dispatch(clearstorageData())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Service)